import React, { useState, useEffect, useRef } from "react";
import "./sideBar.css";
import {
  clearManualStockList,
  clearHinNumber,
  clearIsFetch,
  clearIsFetchExist,
  clearIsFetchStrategy,
  clearIsMatchFound,
  clearManualEntryVisible,
  clearPortfolioList,
  clearStockList,
  clearRequestId,
} from "../../Redux/store/inspecie-transfer";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom"; 


function Sidebar({ isMobile, toggleMenu, isMenuOpen, onSideMenupChange }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const pathToMenuId = {
      "/": 1,
      "/my-profile": 2,
      "/my-investments": 3,
      "/investment-hub": 4,
      "/inspecie-transfer": 5,
      "/my-documents": 6,
      "/reports": 7, 
    };

    const currentMenuId = pathToMenuId[location.pathname];
    if (currentMenuId) {
      setSelectedItem(currentMenuId);
      localStorage.setItem("sideOption", currentMenuId);
    }
  }, [location.pathname]);

  const handleChange = () => {
    toggleMenu();
  };

  const [showTransactionOptions, setShowTransactionOptions] = useState(false);

  const handleTransactionClick = () => {
    setShowTransactionOptions(!showTransactionOptions);
  };

  const menuItems = [
    {
      id: 1,
      label: "Dashboard",
      defaultIcon: "/dashboard-black.svg",
      selectedIcon: "/element-dashboard.svg",
    },
    {
      id: 2,
      label: "My Profile",
      defaultIcon: "/profile-black.svg",
      selectedIcon: "/profile-white.svg",
    },
    {
      id: 3,
      label: "My Investments",
      defaultIcon: "/dollar-circle.svg",
      selectedIcon: "/investment-white.svg",
    },
    {
      id: 4,
      label: "Investment Hub",
      defaultIcon: "/dollar-circle.svg",
      selectedIcon: "/investment-white.svg",
    },
    {
      id: 5,
      label: "Inspecie Transfer",
      defaultIcon: "/stock-black.svg",
      selectedIcon: "/stock-white.svg",
    },
    {
      id: 6,
      label: "My Documents",
      defaultIcon: "/dollar-circle.svg",
      selectedIcon: "/investment-white.svg",
    },
    {
      id: 7,
      label: "Reports",
      defaultIcon: "/note-black.svg",
      selectedIcon: "/note-white.svg",
    },
    {
      id: 8,
      label: "Transaction Request",
      defaultIcon: "/dollar-circle.svg",
      selectedIcon: "/investment-white.svg",
      onClick: () => navigate('/transaction-request'),
    },
  ];
  
  const [selectedItem, setSelectedItem] = useState(
    Number(localStorage.getItem("sideOption")) || 1
  );
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleChangeMenu = (id) => {
    localStorage.setItem("sideOption", Number(id));
    if (id === 5) {
      dispatch(clearHinNumber());
      dispatch(clearManualStockList());
      dispatch(clearIsFetch());
      dispatch(clearIsFetchExist());
      dispatch(clearIsFetchStrategy());
      dispatch(clearIsMatchFound());
      dispatch(clearManualEntryVisible());
      dispatch(clearPortfolioList());
      dispatch(clearStockList());
      dispatch(clearRequestId());
    }
    setSelectedItem(id);
    onSideMenupChange(id);
    toggleMenu();
  };

  const [isImageLoaded, setImageLoaded] = React.useState(false);

  return (
    <div
      className={`lg:block 
    ${
      isMobile
        ? isMenuOpen
          ? "bg-[#F9F9F9] translate-x-0 fixed w-full z-10 top-0 left-0 h-full transition-transform duration-300 "
          : "hidden  translate-x-0   h-full -translate-x-full"
        : "text-black top-0 left-0  w-auto h-full"
    }`}
    >
      <div
        className={`md:w-[18vw] 
    ${isMobile && isMenuOpen ? "w-full" : "w-auto"}`}
      >
        {/* Company Logo */}
        <div className="pr-4 pl-4 flex flex-col items-center">
          <div className="relative w-auto h-20 flex items-center justify-center">
            {/* Shimmer effect */}
            <div
              className={`absolute inset-0 bg-gray-200 animate-pulse ${
                isImageLoaded ? "hidden" : "block"
              }`}
            ></div>
            {/* Actual Image */}
            <img
              src="/Caprock-Logo2.svg"
              alt="Company Logo"
              className={`w-auto top-20 ${isImageLoaded ? "block" : "hidden"}`}
              onLoad={() =>
                setTimeout(function () {
                  setImageLoaded(true);
                }, 100)
              }
            />
          </div>
        </div>

        {/* Menu List */}
        {isImageLoaded && (
          <ul className="mt-4 font-medium p-4">
            {menuItems.map((item) => (
              <li
                key={item.id}
                onMouseEnter={() => setHoveredItem(item.id)}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => {
                  handleChangeMenu(item.id);
                  if (item.onClick) item.onClick();
                }}
                className={`flex items-center mb-4 pl-4 drop-shadow-md border-radius-menu-selected px-6 py-3 cursor-pointer ${
                  selectedItem === item.id || hoveredItem === item.id
                    ? "bg-black text-white"
                    : ""
                }`}
              >
                {/* Icon */}
                <img
                  src={
                    selectedItem === item.id || hoveredItem === item.id
                      ? item.selectedIcon
                      : item.defaultIcon
                  }
                  alt={`${item.label} Icon`}
                  className={`mr-2 inset-0 w-6 h-6  object-contain transition-transform duration-300 ${
                    hoveredItem === item.id ? "scale-110" : "scale-100"
                  }`}
                />
                {/* Label */}
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        )}

        {isMobile && isMenuOpen && (
          <div className="absolute bottom-0 left-0 w-full flex justify-center items-center py-4">
            <button
              onClick={handleChange}
              className="px-2 py-2 bg-black rounded-full shadow-md"
            >
              <img src="/add.svg" alt="Close" className="w-10 h-10" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
